import { FormatMoney } from '../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../lang/LangEnum';
import {
  BusinessPolicyAstLogicalOperator,
  BusinessPolicyComparisonNodeDTO,
  BusinessPolicyConditionNodeDTO,
} from '../../../../../../services/modules/business-policies/businessPolicyCondition.types';
import {
  BusinessPolicyNodeEvaluationDTO,
  BusinessPolicyNodeOutcome,
  BusinessPolicyViolationDTO,
  BusinessPolicyViolationPolicyDTO,
} from '../../../../../../services/modules/business-policies/businessPolicyViolation.types';
import { BusinessPolicyValueInput } from '../../../../../business-policies/domain/businessPolicyCapabilities.types';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { OrderCondition } from '../../../../conditions/interfaces/orderCondition.interface';
import { OrderError } from '../../../sections/OrderEditSections.types';

export enum BusinessPolicyCriterionStatus {
  VIOLATED = 'violated',
  SATISFIED = 'satisfied',
  IGNORED = 'ignored',
}

export interface BusinessPolicyViolationItem {
  productColorId: string;
  productColorCode: string;
  availability?: AvailabilityEnum;
  deliveryWindowName?: string;
}

export interface BusinessPolicyViolationGroupView extends BusinessPolicyViolationItem {
  itemKey?: string;
  expected: number;
  reached: number;
  isViolated: boolean;
}

export interface BusinessPolicyViolationMeasure {
  measureLabel: string;
  comparisonLabel: string;
  valueInput: BusinessPolicyValueInput;
}

export interface BusinessPolicyViolationCriterionView extends BusinessPolicyViolationMeasure {
  nodeId: string;
  status: BusinessPolicyCriterionStatus;
  isGrouped: boolean;
  expected: number | null;
  reached: number | null;
  groups: BusinessPolicyViolationGroupView[];
}

export interface BusinessPolicyViolationBranchView {
  criteria: BusinessPolicyViolationCriterionView[];
  criteriaOperator: BusinessPolicyAstLogicalOperator | null;
  isViolated: boolean;
}

export interface BusinessPolicyViolationView {
  businessPolicy: BusinessPolicyViolationPolicyDTO;
  messageCode: LangEnum;
  branches: BusinessPolicyViolationBranchView[];
}

export interface BusinessPolicyViolationSection {
  condition?: OrderCondition;
  violations: BusinessPolicyViolationView[];
}

export interface BusinessPolicyItemCriterionView extends BusinessPolicyViolationMeasure {
  expected: number;
  reached: number;
}

export interface BusinessPolicyItemViolationView {
  businessPolicy: BusinessPolicyViolationPolicyDTO;
  messageCode: LangEnum;
  itemKey: string;
  item: BusinessPolicyViolationItem;
  criterion?: BusinessPolicyItemCriterionView;
}

export interface ViolationFormatters {
  translate: TranslateType;
  formatMoney: FormatMoney;
}

export interface ToBusinessPolicyViolationViewParams extends ViolationFormatters {
  violation: BusinessPolicyViolationDTO;
  messageCode: LangEnum;
}

export interface GetBusinessPolicyViolationViewsParams extends ViolationFormatters {
  errors: OrderError[];
}

export interface ToCriterionViewParams extends ViolationFormatters {
  node: BusinessPolicyComparisonNodeDTO;
  evaluation?: BusinessPolicyNodeEvaluationDTO;
  firingOutcome: BusinessPolicyNodeOutcome;
}

export interface BuildComparisonLabelParams extends ViolationFormatters {
  node: BusinessPolicyComparisonNodeDTO;
  expected: number | null;
  valueInput: BusinessPolicyValueInput;
}

export interface DnfBranch {
  node: BusinessPolicyConditionNodeDTO;
  criteria: BusinessPolicyComparisonNodeDTO[];
  criteriaOperator: BusinessPolicyAstLogicalOperator | null;
}
